// Expanded, searchable profession list. Custom professions belong to the user
// and are NOT added to this global list.
export const PROFESSIONS = [
  "Creator", "Content Creator", "Influencer", "Entrepreneur", "Founder", "Business Owner",
  "CEO", "Developer", "Software Engineer", "Designer", "UI/UX Designer", "Product Manager",
  "Artist", "Digital Artist", "Illustrator", "Musician", "Singer", "Rapper", "DJ", "Producer",
  "Songwriter", "Trader", "Day Trader", "Crypto Trader", "Investor", "Angel Investor",
  "Athlete", "Coach", "Personal Trainer", "Fitness Creator", "Model", "Fashion Model",
  "Photographer", "Videographer", "Filmmaker", "Editor", "Marketing", "Growth Marketer",
  "Social Media Manager", "Sales", "Real Estate Agent", "Realtor", "Finance", "Accountant",
  "Gamer", "Streamer", "Esports Player", "Fashion Designer", "Stylist", "Fitness Coach",
  "Entertainer", "Actor", "Comedian", "Dancer", "Podcaster", "Writer", "Author", "Journalist",
  "Educator", "Teacher", "Public Speaker", "Consultant", "Technology", "Data Scientist",
  "AI Engineer", "Web3 Developer", "Crypto Founder", "NFT Artist", "Student", "Chef",
  "Barber", "Tattoo Artist", "Makeup Artist", "Nutritionist", "Life Coach", "Motivational Speaker",
  "Real Estate Investor", "Venture Capitalist", "Startup Advisor", "Community Manager",
];
